import React from "react";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Faísca do piso: mensagem compartilhada, curta, que interrompe o automático.
 */
export default function VoFloorSpark({ spark, onDismiss, onEcho }) {
  if (!spark?.hook) return null;
  return (
    <Box
      data-vo-floor-spark={spark.id}
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 8,
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pt: { xs: 10, md: 12 },
        px: 2,
      }}
    >
      <Box
        sx={{
          pointerEvents: "none",
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse at 50% 42%, rgba(16,10,8,0.18) 0%, rgba(16,10,8,0.02) 58%, transparent 72%)",
          animation: "voSparkVeil 16s ease both",
          "@keyframes voSparkVeil": {
            "0%": { opacity: 0 },
            "8%": { opacity: 1 },
            "82%": { opacity: 1 },
            "100%": { opacity: 0 },
          },
        }}
      />
      <Box
        sx={{
          pointerEvents: "auto",
          position: "relative",
          width: "min(100%, 520px)",
          px: { xs: 2, md: 2.6 },
          py: { xs: 1.6, md: 2 },
          borderRadius: 3,
          bgcolor: "rgba(18,14,12,0.88)",
          border: "1px solid rgba(232,196,138,0.42)",
          boxShadow: "0 18px 48px rgba(0,0,0,0.45), 0 0 0 8px rgba(232,196,138,0.08)",
          animation: "voSparkIn 16s ease both",
          "@keyframes voSparkIn": {
            "0%": { opacity: 0, transform: "translateY(16px) scale(0.94)" },
            "8%": { opacity: 1, transform: "translateY(0) scale(1)" },
            "82%": { opacity: 1, transform: "translateY(0) scale(1)" },
            "100%": { opacity: 0, transform: "translateY(-10px) scale(0.98)" },
          },
        }}
      >
        <Stack direction="row" alignItems="flex-start" spacing={1}>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              sx={{
                fontSize: "0.68rem",
                fontWeight: 800,
                letterSpacing: "0.08em",
                wordSpacing: "0.16em",
                textTransform: "uppercase",
                color: "#e8c48a",
                mb: 0.6,
              }}
            >
              Um sopro no piso
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "1.45rem", md: "1.75rem" },
                fontWeight: 800,
                color: "#fff8ee",
                lineHeight: 1.15,
                letterSpacing: "-0.02em",
              }}
            >
              {spark.hook}
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontSize: "0.98rem",
                fontWeight: 600,
                color: "#f1e6d4",
                lineHeight: 1.45,
              }}
            >
              {spark.body}
            </Typography>
            {spark.nudge ? (
              <Typography
                sx={{
                  mt: 1,
                  fontSize: "0.78rem",
                  fontWeight: 700,
                  color: "#e8c48a",
                }}
              >
                {spark.nudge}
              </Typography>
            ) : null}
          </Box>
          <IconButton
            size="small"
            aria-label="Fechar reflexão"
            onClick={onDismiss}
            sx={{ color: "rgba(255,255,255,0.7)", mt: -0.4 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
          <Button
            size="small"
            onClick={onEcho}
            sx={{
              textTransform: "none",
              fontWeight: 800,
              borderRadius: 999,
              px: 1.6,
              bgcolor: "#e8c48a",
              color: "#3a2414",
              "&:hover": { bgcolor: "#f3d7a8" },
            }}
          >
            Sinto isso
          </Button>
          <Button
            size="small"
            onClick={onDismiss}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: "#c4b8a8",
            }}
          >
            Depois
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
